import React, {lazy} from 'react';
import {isAzureAuth, isDefaultAuth, isAbbvieAuth} from '@/app/AuthUtils';
import AuthContainer from '@/app/wrapper/AuthContainer';

const DefaultLoginPage = lazy(() =>
    import(/* webpackChunkName: "defaultLogin" */ '@/page/auth/LoginPage')
);

const SsoAzureLoginPage = lazy(() =>
    import(/* webpackChunkName: "azureLogin" */ '@/app/auth/azure/SsoAzureLoginPage')
);

const SsoAbbvieLoginPage = lazy(() =>
    import(/* webpackChunkName: "abbvieLogin" */ '@/app/auth/abbvie/SsoAbbvieLoginPage')
);

const ForgetPassPage = lazy(() =>
    import(/* webpackChunkName: "defaultForgetPass" */ '@/page/auth/ForgetPassPage')
);

const SsoAzureLogoutPage = lazy(() =>
    import(/* webpackChunkName: "azureLogout" */ '@/app/auth/azure/SsoAzureLogoutPage')
);

const PasswordResetPage = lazy(() =>
    import(/* webpackChunkName: "defaultPasswordReset" */ '@/page/auth/PasswordResetPage')
);

const ChangePassPage = lazy(() =>
    import(/* webpackChunkName: "defaultChangePass" */ '@/page/auth/ChangePassPage')
);

const commonRoutes = [
    isAzureAuth && {
        path: '/login',
        element: <SsoAzureLoginPage />,
    },

    isAbbvieAuth && {
        path: '/login',
        element: <SsoAbbvieLoginPage />,
    },

    isDefaultAuth && {
        path: '/login',
        element: <DefaultLoginPage />,
    },

    {
        path: '/abbvie',
        element: <DefaultLoginPage />,
    },

    isAzureAuth && {
        path: '/logout',
        element: <SsoAzureLogoutPage />,
    },

    isDefaultAuth && {
        path: '/forget',
        element: <ForgetPassPage />,
    },

    isDefaultAuth && {
        path: '/password-reset',
        element: <PasswordResetPage />,
    },
    isDefaultAuth && {
        path: '/change-passord',
        element: (
            <AuthContainer>
                <ChangePassPage />
            </AuthContainer>
        ),
    },
].filter(Boolean);

export default commonRoutes;
